import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-white mt-auto">
      <div className="max-w-container mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center gap-4 py-6 sm:py-8">
          {/* Logo + name */}
          <div className="flex items-center gap-2">
            <AppLogo size={28} />
            <span className="font-display text-base font-semibold text-foreground">CakePalace</span>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
            <Link href="/product-shop" className="text-sm font-medium text-muted hover:text-foreground transition-colors">Shop</Link>
            <Link href="/cart" className="text-sm font-medium text-muted hover:text-foreground transition-colors">Cart</Link>
            <Link href="/admin-dashboard" className="text-sm font-medium text-muted hover:text-foreground transition-colors">Admin</Link>
            <a href="https://wa.me/233245578278" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-muted hover:text-primary transition-colors">WhatsApp</a>
            <Link href="#" className="text-sm font-medium text-muted hover:text-foreground transition-colors">Privacy</Link>
            <Link href="#" className="text-sm font-medium text-muted hover:text-foreground transition-colors">Terms</Link>
          </nav>

          {/* Copyright */}
          <p className="text-xs text-muted-light text-center">© 2026 CakePalace. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}